import statusViewGenerator from './StatusViewGenerator.tsx';

import successImage from './images/success.png';

const SuccessContent = statusViewGenerator(successImage);

export default SuccessContent;
